import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { useTeams } from '@/hooks/api/0180_teams';
import { SimpleTextFormat } from '@/components/element/SimpleTextFormat';
import { Link, useParams } from 'react-router-dom';
import { TeamLogic } from '@/hooks/api/models/logics';

export const TeamsElement = () => {
  const { _w_, me } = useCurrentWorkspace();
  const { data } = useTeams({ identifier: _w_!.identifier });

  if (data == null) return <></>;

  if (data.length == 0)
    return (
      <div className="card-body pt-0">
        <p className="card-description text-sm">登録されているチームがありません。</p>
      </div>
    );

  return (
    <div className="card-body pt-0">
      <div className="table-responsive">
        <table className="table align-items-center">
          <thead>
            <tr>
              <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">チーム名</th>
              <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">メモ</th>
              <th
                className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2 text-end"
                style={{ width: 80 }}
              >
                メンバー数
              </th>
              <th className="text-secondary opacity-7" style={{ width: 55 }}></th>
            </tr>
          </thead>
          <tbody>
            {data.map((t) => (
              <tr key={`team-${t.id}`}>
                <td>
                  <h6 className="mb-0">{t.name}</h6>
                </td>
                <td className="text-secondary text-xs text-wrap">
                  <SimpleTextFormat content={t.description || ''} />
                </td>
                <td className="text-secondary text-xs font-weight-bold text-end">{t.team_members.length}</td>
                <td>
                  <Link
                    to={`/w/${_w_!.identifier}/setting/teams/${t.id}`}
                    className="btn btn-icon-only btn-outline-info"
                  >
                    <i className="fas fa-cog text-info text-sm"></i>
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
